import { Recipe, RecipeCreate, RecipeListItem, RecipeUpdate, SubgraphResponse } from './types.js';
import { authService } from '../auth/AuthService.js';

export async function loadRecipe(recipeId: string): Promise<Recipe> {
  const response = await fetch(`/api/recipe/${recipeId}`);
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
}


export async function updateRecipe(recipeId: string, recipeUpdate: RecipeUpdate): Promise<Recipe> {
  const response = await fetch(`/api/recipe/${recipeId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...authService.getAuthHeaders(),
    },
    body: JSON.stringify(recipeUpdate),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: 'Failed to update recipe' }));
    throw new Error(error.detail || `HTTP error! status: ${response.status}`);
  }

  return response.json();
}


export async function createRecipe(recipeCreate: RecipeCreate): Promise<Recipe> {
  const body: Record<string, unknown> = {
    name: recipeCreate.name,
  };
  if (recipeCreate.description) body.description = recipeCreate.description;
  if (recipeCreate.ingredientId) body.ingredientId = recipeCreate.ingredientId;
  if (recipeCreate.quantity) body.quantity = recipeCreate.quantity;

  const response = await fetch('/api/recipes/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authService.getAuthHeaders(),
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: 'Failed to create recipe' }));
    throw new Error(error.detail || `HTTP error! status: ${response.status}`);
  }

  return response.json();
}


export async function deleteRecipe(recipeId: string): Promise<void> {
  const response = await fetch(`/api/recipe/${recipeId}`, {
    method: 'DELETE',
    headers: {
      ...authService.getAuthHeaders(),
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: 'Failed to delete recipe' }));
    throw new Error(error.detail || `HTTP error! status: ${response.status}`);
  }
}


// ── Unified search endpoint ──

export async function searchRecipeList(params: {
  limit?: number;
  offset?: number;
  ingredientIds?: string[];
  tagIds?: string[];
} = {}): Promise<RecipeListItem[]> {
  const query = new URLSearchParams();
  if (params.limit !== undefined) query.set('limit', String(params.limit));
  if (params.offset !== undefined) query.set('offset', String(params.offset));
  if (params.ingredientIds?.length) {
    for (const id of params.ingredientIds) {
      query.append('ingredient_ids', id);
    }
  }
  if (params.tagIds?.length) {
    for (const id of params.tagIds) {
      query.append('tag_ids', id);
    }
  }
  const response = await fetch(`/api/recipes/search?${query}`);
  if (!response.ok) {
    throw new Error(`Search failed: ${response.status}`);
  }
  return response.json();
}


export async function getNodeSubgraph(nodeId: string): Promise<SubgraphResponse> {
  const response = await fetch(`/api/nodes/${nodeId}/subgraph`);
  if (!response.ok) {
    throw new Error(`Subgraph fetch failed: ${response.status}`);
  }
  return response.json();
}
